import React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from "styled-components";

import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

const query = graphql`
  {
    allFile(
      filter: { relativeDirectory: { eq: "brand" }, ext: { ne: "svg" } }
    ) {
      nodes {
        name
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED)
        }
      }
    }
  }
`;

const Brand = () => {
  const data = useStaticQuery(query);
  const nodes = data.allFile.nodes;

  return (
    <Wrapper>
      <div className="container">
        <div className="col-sm-12">
          <Swiper
            spaceBetween={0}
            slidesPerView={4}
            navigation
            className="brandsSwiper"
          >
            {nodes.map((image, index) => {
              const { name } = image;
              const pathToImage = getImage(image);
              return (
                <SwiperSlide key={index}>
                  <div>
                    <Link to="#" className="item offset-1">
                      <GatsbyImage image={pathToImage} alt={name} />
                    </Link>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </Wrapper>
  );
};

export default Brand;

export const Wrapper = styled.section`
  padding: 30px 0;
  background-image: linear-gradient(to right, #5268c2, #fff, #fff, #5268c2);

  .item {
    display: grid;
    place-items: center;

    img {
      object-fit: contain;
      width: 100%;
      height: 55px !important;

      :hover {
        filter: brightness(1.3) drop-shadow(2px 2px 3px #5268c2);
        transition: all 0.3s ease-in-out;
        transform: scale(1.1);
      }
    }
  }

  .swiper-button-prev,
  .swiper-button-next {
    color: #fff !important;
    visibility: hidden;
    @media (min-width: 992px) {
      visibility: visible;
    }
  }
`;
